import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import IssueCategory from "../../Utility/Crud/IssueCategory";

export default class ChipIssueCategory extends Chip {
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const color = this.props.issueCategory
      ? IssueCategory.getColor()
      : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {IssueCategory.getIcon({ fontSize: "small", sx: { color: iconColor } })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The issueCategory name.
   */
  getLabel() {
    return this.props.issueCategory
      ? IssueCategory.getDisplayName(this.props.issueCategory)
      : "None";
  }
}
